import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { notify } from "../../services/notify.js";
import Offer2 from "../checkout/offer2.js";
import "../checkout/checkout.css";

const baseAPI_URL = process.env.REACT_APP_BACKEND_API_BASE_ENDPOINT;

const CACHED_OFFERS = {
  DEFAULT: {
    code: "DEFAULT",
    headline: "Torne-se aluno do site Dom\u00ednio El\u00e9trico!",
    id: 1,
    interest_rate: "0.0259",
    offer_type: "DEFAULT",
    period: "QUINQUENNIAL",
    prices: {
      base: "397",
      credit_card: {
        1: "397.00", 2: "206.24", 3: "139.25", 4: "105.76",
        5: "85.67", 6: "72.29", 7: "62.74", 8: "55.58",
        9: "50.02", 10: "45.57", 11: "41.94", 12: "38.91",
      },
      pix: "397",
    },
  },
  DEFAULT2: {
    code: "DEFAULT2",
    headline: "Torne-se aluno do site Dom\u00ednio El\u00e9trico!",
    id: 1,
    interest_rate: "0.0259",
    offer_type: "DEFAULT",
    period: "QUINQUENNIAL",
    prices: {
      base: "197",
      credit_card: {
        1: "197.00", 2: "102.34", 3: "69.10", 4: "52.48",
        5: "42.51", 6: "35.87", 7: "31.13", 8: "27.58",
        9: "24.82", 10: "22.61", 11: "20.81", 12: "19.31",
      },
      pix: "197",
    },
  },
};

// Offer-only section for the sales page. Shows the same converting offer block
// and, on click, sends the user to the dedicated single-step checkout page,
// preserving the query parameters (e.g. `o`, `utm_source`).
const OfferSection = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const query = new URLSearchParams(location.search);
  const codeFromQuery = query.get("o") ?? "DEFAULT";

  const [offer, setOffer] = useState(null);
  const [isOfferLoading, setIsOfferLoading] = useState(false);

  useEffect(() => {
    async function fetchOffer() {
      if (CACHED_OFFERS[codeFromQuery]) {
        setOffer(CACHED_OFFERS[codeFromQuery]);
        return;
      }
      try {
        setIsOfferLoading(true);
        const response = await fetch(
          `${baseAPI_URL}/offers/get-offer/${codeFromQuery}`,
          { method: "GET", headers: { "Content-Type": "application/json" } }
        );
        const result = await response.json();
        setOffer(response.ok ? result : null);
      } catch (error) {
        console.error("Error getting offer:", error);
        setOffer(null);
      } finally {
        setIsOfferLoading(false);
      }
    }
    fetchOffer();
  }, [codeFromQuery]);

  const handleGoToCheckout = (e) => {
    e.preventDefault();
    notify(
      "CHECKOUT: offer click",
      `Usuário clicou na oferta da página de vendas e foi para o checkout. Params: ${location.search || "(nenhum)"}`
    );
    navigate(`/checkout${location.search}`);
  };

  if (isOfferLoading) {
    return <div className="loading-message">Carregando oferta...</div>;
  }
  if (!offer) {
    return <div className="loading-message">Oferta não encontrada.</div>;
  }

  return (
    <section id="form" className="checkout">
      <div className="checkout-content">
        <Offer2 offer={offer} handleSubmit={handleGoToCheckout} />
      </div>
    </section>
  );
};

export default OfferSection;
